export const notUndefined = <T>(item: T | undefined): item is T => {
  return item !== undefined;
};

export const notNull = <T>(item: T | null): item is T => {
  return item !== null;
};

export const objectKeys = <T extends object>(obj: T) => {
  return Object.keys(obj) as Array<keyof T>;
};

/**
 * A number that can actually be compared or arithmetic done with. A field left empty reads as
 * undefined, and one holding a partly typed entry reads as NaN — neither of which may be treated
 * as a value.
 */
export const usableNumber = (value?: number | null): value is number =>
  typeof value === 'number' && !Number.isNaN(value);
